import React, { Component } from 'react';
import _ from 'lodash';

import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Typography,
} from '@material-ui/core';


const styles = (theme: Theme) => createStyles({
	root: {
		flexShrink: 0,
		color: theme.palette.text.secondary,
		marginLeft: theme.spacing.unit * 2.5,
		'& p': {
			color: 'rgb(66 74 85)',
			verticalAlign: 'middle'
		}
	},
	iconButton: {
		padding: '5px 0px',
		borderRadius: 2
	}
});

//@ts-ignore
interface ContentPaginationProps extends WithStyles<typeof styles> {
	classes: any,
	onChangePage: Function,
	count: number,
	page: number,
	rowsPerPage: number

}

class ContentPagination extends Component<ContentPaginationProps>{

	handleFirstPageButtonClick = (event: any) => {
		this.props.onChangePage(event, 1);
	};

	handleBackButtonClick = (event: any) => {
		this.props.onChangePage(event, this.props.page - 1);
	};

	handleNextButtonClick = (event: any) => {
		this.props.onChangePage(event, this.props.page + 1);
	};

	handleLastPageButtonClick = (event: any) => {
		this.props.onChangePage(
			event,
			Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage)),
		);
	};

	render() {
		const { classes, page, count, rowsPerPage } = this.props;

		let startCount = count == 0 ? count : (rowsPerPage * (page - 1) + 1);
		let endCount = rowsPerPage * (page - 1) + (rowsPerPage < count ? rowsPerPage : count);
		if (endCount > count) {
			endCount = count;
		}
		return (
			<>
				<div className={classes.root}>
					<IconButton classes={{ root: classes.iconButton }}
						onClick={this.handleFirstPageButtonClick}
						disabled={page === 1}
						aria-label="First Page"
					>{page === 1 ?
						<img src="/assets/svg/myLibrary/pagination/double-left-arrow.svg" alt="doubleArrow" /> :
						<img src="/assets/svg/contentRequest/nav-double-arrow.svg" alt="doubleArrow" />
						}
					</IconButton>
					<IconButton classes={{ root: classes.iconButton }}
						onClick={this.handleBackButtonClick}
						disabled={page === 1}
						aria-label="Previous Page"
					>{page === 1 ?
						<img src="/assets/svg/myLibrary/pagination/single-left-arrow.svg" alt="singleArrow" />
						: <img src="/assets/svg/contentRequest/nav-arrow.svg" alt="singleArrow" />
						}
					</IconButton>
					<Typography style={{ display: 'inline' }} variant="body1">{startCount} - {endCount} of {count}</Typography>
					<IconButton classes={{ root: classes.iconButton }}
						onClick={this.handleNextButtonClick}
						disabled={page >= Math.ceil(count / rowsPerPage)}
						aria-label="Next Page"
					>
						<img src="/assets/svg/myLibrary/pagination/arrow-right.svg" alt="singleArrow" />
					</IconButton>
					<IconButton classes={{ root: classes.iconButton }}
						onClick={this.handleLastPageButtonClick}
						disabled={page >= Math.ceil(count / rowsPerPage)}
						aria-label="Last Page"
					>
						<img src="/assets/svg/myLibrary/pagination/double-arrow-right.svg" alt="singleArrow" />
					</IconButton>
				</div>
			</>
		);
	}
}

// @ts-ignore
export default withStyles(styles)(ContentPagination);

